export default __webpack_public_path__ + "static/iconLaRebaja-a4f912f1dca3946fc8c43df49bc56391.png";